import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Flame } from "lucide-react";

const MilestoneBanner = () => {
  const { user } = useAuth();
  const [streak, setStreak] = useState(null);

  useEffect(() => {
    if (!user) {
      setStreak(null);
      return;
    }
    api.get("/me/streak").then(({ data }) => setStreak(data.streak)).catch(() => {});
  }, [user]);

  if (!user || streak === null) return null;

  return (
    <div
      data-testid="milestone-banner"
      className="fixed bottom-6 right-6 z-40 glass rounded-full px-5 py-3 flex items-center gap-3 shadow-2xl"
    >
      <Flame size={18} className="text-teal-400" />
      <div className="text-xs">
        <div className="text-neutral-400 uppercase tracking-wider">Pivot Streak</div>
        <div className="text-teal-200 font-semibold text-sm" data-testid="milestone-streak-value">
          {streak} {streak === 1 ? "day" : "days"}
        </div>
      </div>
    </div>
  );
};

export default MilestoneBanner;
